<!-- Universal Message Component -->

<template>
	<div class="uni-mess">
		<div class="banner">
			<UniIcon 
				:ico="messType.icon"
				:color="messType.color"
				w="40"
				h="40"
			/>
			<div class="title">
				{{ compData.title }}
			</div>
		</div>
		<div class="main-mess">
			<div class="mess-line" v-for="(line, idx) in messLines" :key="'messline'+idx">
				{{ line }}
			</div>
		</div>
	</div>
</template>

<script>
import { m } from "@/utils/utils"
import CfgApp from "@/assets/cfg/CfgApp.json";
export default {
	data() {
		return {
			messTypes: CfgApp.messTypes,
			messType: {},
			messLines: [
				"server not available",
				"wrong input",
			],
			infoLines: [],
		}
	},
	props: {
		compData: { type: Object, default: function () {return {}} },
	},
	created() {
		m("uni mess created", this.compData);
		if (typeof this.compData.mess == "string") {
			this.messLines = [this.compData.mess]
		} else {
			this.messLines = this.compData.mess;
		}

		this.messType = this.messTypes[this.compData.messType] || this.messTypes.default;

	},
}
</script>

<style scoped>

.uni-mess {
	height: 100%;
	overflow: auto;
	padding: 10px;
	border: solid 0px #369;
}

.banner {
	height: 50px;
	overflow: hidden;
	white-space: nowrap;
	vertical-align: middle;
	padding: 0px 0px 0px 20px;
	border: solid 0px #C30;
}

.title {
	display: inline-block;
	height: 40px;
	overflow: hidden;
	white-space: nowrap;
	padding: 10px 0px 0px 20px;
	border: solid 0px #369;
}

.main-mess {
	max-height: 160px;
	overflow: auto;
	border: solid 0px #090;
}

.mess-line {
	height: 25px;
	overflow: auto;
	border: solid 0px #F93;
}


</style>
